import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function PlayItOutPage() {
  const [influenceNetwork, setInfluenceNetwork] = useState('');
  const [conflictStory, setConflictStory] = useState('');
  const [reflections, setReflections] = useState('');

  return (
    <TaskPage
      phase="engage"
      title="Play It Out"
      pageNumber={6}
      instruction="Build your influence network. Place each stakeholder as a card; draw arrows for influence/decision paths. Mark hotspots where misalignment could occur."
      whyItMatters="The build → story → reflect cycle deepens meaning, lowers stress, and improves recall of agreements."
      coachRail={{
        timing: "10-15 minutes",
        tips: "Optional but powerful. Use this for team sessions to visualize relationships.",
        debrief: "What changed in our stakeholder list, cadence, or agreements?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Build: Influence Network</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">
            Place each stakeholder as a card; draw arrows for influence/decision paths. Mark hotspots where misalignment could occur.
          </p>
          <TextArea
            label="Influence network notes"
            value={influenceNetwork}
            onChange={(e) => setInfluenceNetwork(e.target.value)}
            placeholder="Describe the influence network, decision paths, and potential hotspots..."
            rows={6}
          />
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Story: Likely Conflict</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">
            (Pairs) Tell one likely conflict and how you'll address it using your agreements.
          </p>
          <TextArea
            label="Conflict scenario and resolution"
            value={conflictStory}
            onChange={(e) => setConflictStory(e.target.value)}
            placeholder="Describe a likely conflict and how you'll address it..."
            rows={5}
          />
        </div>

        <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
          <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">Reflect: What Changed?</h3>
          <p className="text-sm text-[var(--green)] dark:text-[var(--text-ter)] mb-4">
            (Team) What changed in our stakeholder list, cadence, or agreements?
          </p>
          <TextArea
            label="Reflection notes"
            value={reflections}
            onChange={(e) => setReflections(e.target.value)}
            placeholder="What insights did we gain? What should we adjust?"
            rows={5}
          />
        </div>

        <Callout type="tip" phase="engage">
          <p className="text-sm">This exercise works best in pairs or small teams. Use physical or digital cards if possible.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






